import React, { useCallback, useRef } from 'react';

import { Box } from '@mui/material';
import { Form } from '@formio/react';

import useMutationObserver from 'hooks/useMutationObserver';
import {
  fixCheckboxSelectionBug,
  fixRadioSelectionBug,
} from 'formio/framework/templates/utils';
import { capitalizeFirstLetter, spinner } from 'utils/string';

const FormIO = ({ form, onCancel, onSubmit }) => {
  const rootRef = useRef(null);

  const setupExtraActions = ({ onCancel } = {}) => {
    if (onCancel) {
      const cancelBtn =
        rootRef?.current?.getElementsByClassName?.('btn-wizard-cancel')?.[0];
      cancelBtn?.addEventListener?.('click', onCancel);
    }
  };
  const setup = useCallback(() => setupExtraActions({ onCancel }), [onCancel]);
  useMutationObserver(rootRef, setup);

  const handleNavPage = ({ submission: { data } }) => {
    fixRadioSelectionBug(data, rootRef);
    fixCheckboxSelectionBug(data, rootRef);
  };

  const handleChange = ({ data }) => {
    fixRadioSelectionBug(data, rootRef);
    fixCheckboxSelectionBug(data, rootRef);
  };

  return (
    <Box
      ref={rootRef}
      sx={{
        height    : '100%',
        width     : '100%',
        '& > div' : { height: '100%' },
        alignSelf : 'center',
      }}>
      <Form
        formReady={() => setupExtraActions({ onCancel })}
        onNextPage={handleNavPage}
        onPrevPage={handleNavPage}
        onChange={handleChange}
        onSubmit={onSubmit}
        form={form}
        options={{ template: 'dailySurvey', noAlerts: true }}
      />
    </Box>
  );
};

export default FormIO;
